<template>
    <!-- bidirectional data binding（双向数据绑定） -->
    <div class="">
        <div id="toolbar">
            <button class="ql-bold"></button>
            <select class="ql-size" defaultValue="14">
                <option :value="size" v-for="size in sizes"></option>
            </select>
            <span class="ql-formats">
                <select class="ql-color" defaultValue=""></select>
            </span>
            <span class="ql-formats">
                <select class="ql-align" defaultValue="">
                    <option value=""></option>
                    <option value="center"></option>
                    <option value="right"></option>
                    <option value="justify"></option>
                </select>
            </span>
            <button class="ql-emoji-x"></button>
        </div>
        <div class="quill-editor-view" ref="quillEditorView">
            <quill-editor v-model="content"
                          ref="myQuillEditor"
                          :options="editorOption"
                          @blur="onEditorBlur($event)"
                          @focus="onEditorFocus($event)"
                          @ready="onEditorReady($event)">
            </quill-editor>
            <div class="bg-green text-white complete padding-tb-xs padding-lr-lg text-df" @click="complete">完成</div>
        </div>
    </div>

</template>
<script>
  import App from '../util/comfun'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import "quill-emoji/dist/quill-emoji.css";
  import { quillEditor,Quill } from 'vue-quill-editor'
  import quillEmoji from "quill-emoji";
  Quill.register('modules/quillEmoji',quillEmoji)
  // 新建的css文件的保存位置，如不同，需要修改
  import "../../static/quillEditor.css";
  // 自定义的字体，注意下面的内容要和css里面对应上
  var fonts = [
    "SimSun",
    "SimHei",
    "Microsoft-YaHei",
    "KaiTi",
    "FangSong",
    "Arial",
    "Times-New-Roman",
    "sans-serif",
  ];
  // 自定义字号的大小，注意下面的内容要和css里面对应上
  var sizes = ['10px','12px','14px', "16px", "18px", "20px", "22px", "26px", "28px", "30px"];

  var Size = Quill.import("formats/size");
  Size.whitelist = sizes;
  var Font = Quill.import("formats/font");
  Font.whitelist = fonts; //将字体加入到白名单
  Quill.register(Font, true);

  /*
  let fontSizeStyle = Quill.import('attributors/style/size')
  fontSizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '36px']
  Quill.register(fontSizeStyle, true)
  */
  //font-size 自定义文字大小 https://www.jianshu.com/p/3a96f9469c03
  var toolbarOptions = [
    ['bold', 'italic', 'underline',{ 'size': sizes }],
    //[],  // custom dropdown
    //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'indent': '-1' }, { 'indent': '+1' }, { 'align': [] }],
    [{ 'color': [] },'emoji','font'],
  ];
  export default {
    data () {
      return {
        sizes:sizes,
        //content: '<h2>I am Example</h2><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><p><h2>I am Example</h2></p><h2>I am Example</h2><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><p><h2>I am Example</h2></p>',
        content:'',
        editorOption: {
          bounds:".quill-editor-view",
          // some quill options
          //theme: 'bubble',
          modules: {
            "emoji-toolbar": true,
            //"emoji-textarea": true,
            //"emoji-shortname": true,
            //toolbar: toolbarOptions,
            toolbar: {container: `#toolbar`},
            clipboard: {
              matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
            },
          },
          placeholder: '请输入...',
          theme: 'snow',  // or 'bubble'

        }
      }
    },
    components:{
      quillEditor,
    },
    methods:{
      handleCustomMatcher(node, Delta) {
        let ops = [];
        Delta.ops.forEach(op => {
          //console.error(op.insert)
          if (op.insert && typeof op.insert === 'string') {
            ops.push({
              insert: op.insert,
              attributes: op.attributes, //文字样式（包括背景色和文字颜色等)
            });
          } else {
//            if(op.insert&&op.insert.image&&op.insert.image.includes(';base64,')){
//              ops.push(op)
//            }
//            this.$message.warning("消息內容不支持圖片！");
          }
        });
        Delta.ops = ops;
        return Delta;
      },
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
        this.$refs.quillEditorView.style.height='100%';
      },
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
        //this.$refs.quillEditorView.style.height='calc(50% - 42px)';
        setTimeout(()=>{
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // 可选，平滑滚动
          });
        },300)
      },
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      },
      complete(){
        //let Content=this.editor.container.firstChild.innerHTML
        //console.error(Content)
        this.postMessage({html:this.editor.container.firstChild.innerHTML,id:this.$route.params.id||''})
        setTimeout(()=>{
          this.navigateBack()
        })
      },
      navigateBack(){
        if(App.hasTT()){
          tt.miniProgram.navigateBack()
        }else{
          wx.miniProgram.navigateBack()
        }
      },
      postMessage(dataObj){
        if(App.hasTT()){
          tt.miniProgram.postMessage({data: {action: 'h5editor', ...dataObj}})
        }else {
          wx.miniProgram.postMessage({data: {action: 'h5editor', ...dataObj}})
        }
      },
      getContent(){
        if(!this.$route.params.id) return;
        App.demand('/activity/data/queryList','POST',{idList:[this.$route.params.id]}).then(res=>{
            this.content=res.data[0].content
        })
      },
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    mounted(){
      console.log('this is current quill instance object', this.editor)
      this.getContent()
    },

  }
</script>

<style scoped>
    /*
    .quill-editor {
        height: 100%;
        display: flex;
        flex-direction: column-reverse;
    }
    .quill-editor  >>>.ql-container{
        flex: 1;
        border-top: 1px solid #ccc;
    .ql-editor{
         max-height: 100%;
     }
    }
    .quill-editor  >>>.ql-toolbar{
        border-top: 0;
    }
    .quill-editor  >>>.ql-picker-options{
        top: 0px;
        transform: translate(0, -100%);
    }
    */
    /*
    .quill-editor-view{
        width: 100vw;
        height: calc(100vh - 60px);
        overflow-y: auto;
        box-sizing: border-box;
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .quill-editor >>>.ql-toolbar.ql-snow{
        position: absolute;
        top: 0;
        width: 100%;
        height: 60px;
        z-index: 9999;
    }
    #app{
        min-height: auto!important;
    }
    */
    .complete{
        position: fixed;
        right:20px;
        top:6px;
        z-index: 9;
    }
    .quill-editor-view{
        width: 100vw;
        /*height: calc(50% - 42px);*/
        height: 100%;
        overflow-y: auto;
        box-sizing: border-box;
        padding-top: 42px;
    }
    #toolbar{
        position: fixed;
        top:0;
        width: 100%;
        background-color: #fefefe;
        z-index: 9;
    }
</style>


// WEBPACK FOOTER //
// src/pages/editor.vue